module.exports = __webpack_public_path__ + "static/img/mic.9bacb83.jpg";